import {
    DEFAULT_LOGGED_IN_START_PAGE_CONFIG,
    DEFAULT_LOGGED_OUT_START_PAGE_CONFIG
} from './constants';
import type { StartPageConfigInitData } from './types';

export const mapConfig = (
    config: StartPageConfigInitData,
    isLoggedIn?: boolean
) => {
    const { contentLoggedIn, contentLoggedOut, ...restOfConfig } = config || {};
    const content = isLoggedIn ? contentLoggedIn : contentLoggedOut;

    if (!config || !content) {
        if (isLoggedIn) {
            return DEFAULT_LOGGED_IN_START_PAGE_CONFIG;
        }
        return DEFAULT_LOGGED_OUT_START_PAGE_CONFIG;
    }

    return {
        ...restOfConfig,
        content
    };
};
